<template>
  <div class="chip-collapse" :class="{ 'cc-neutral': color !== 'blue' }">
    <!-- header: counter + search toggle + collapse toggle -->
    <div class="cc-bar">
      <span class="cc-count">{{ items.length }}</span>

      <transition name="cc-slide">
        <div v-if="searching" class="cc-search">
          <i class="fal fa-search"></i>
          <input
            ref="input"
            v-model="query"
            type="text"
            :placeholder="placeholder"
            @keydown.esc="closeSearch"
          />
          <i v-if="query" class="fal fa-times cc-clear" @click="query = ''"></i>
        </div>
      </transition>

      <button
        type="button"
        class="cc-btn"
        :class="{ active: searching }"
        @click="toggleSearch"
      >
        <i class="fal fa-search"></i>
      </button>
      <button
        v-if="items.length > 1"
        type="button"
        class="cc-btn"
        @click="open = !open"
      >
        <i class="fal fa-chevron-down cc-arrow" :class="{ rotated: open }"></i>
      </button>
    </div>

    <!-- chips -->
    <div class="cc-chips">
      <v-chip
        v-for="(i, idx) in visible"
        :key="idx"
        :color="color"
        dark
        :close="removable"
        close-icon="fal fa-times"
        class="ml-2 mb-2"
        @click:close="$emit('remove', i)"
      >
        {{ i[labelKey] }}
      </v-chip>
      <v-chip
        v-if="hiddenCount > 0"
        outlined
        :color="color"
        class="ml-2 mb-2 cc-more"
        @click="open = true"
      >
        +{{ hiddenCount }}
      </v-chip>
      <span v-if="query && !filtered.length" class="cc-empty">—</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
    labelKey: { type: String, default: "name" },
    color: { type: String, default: "blue" },
    removable: { type: Boolean, default: false },
    placeholder: { type: String, default: "بحث..." },
  },
  data() {
    return { open: false, searching: false, query: "" };
  },
  computed: {
    filtered() {
      const q = this.query.trim().toLowerCase();
      if (!q) return this.items;
      return this.items.filter((i) =>
        String(i[this.labelKey] || "").toLowerCase().includes(q)
      );
    },
    // while searching, show every match; otherwise 1 chip when collapsed
    visible() {
      if (this.open || this.query) return this.filtered;
      return this.filtered.slice(0, 1);
    },
    hiddenCount() {
      return this.filtered.length - this.visible.length;
    },
  },
  methods: {
    toggleSearch() {
      this.searching = !this.searching;
      if (this.searching) {
        this.$nextTick(() => this.$refs.input && this.$refs.input.focus());
      } else {
        this.query = "";
      }
    },
    closeSearch() {
      this.searching = false;
      this.query = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.chip-collapse {
  min-width: 140px;
  padding: 6px 0;
}
.cc-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  justify-content: center;
}
// neutral (dark grey) accents for columns that use the default chip colour
.cc-neutral {
  .cc-count {
    background: linear-gradient(135deg, #424242, #616161);
  }
  .cc-btn {
    color: #424242;
    &:hover,
    &.active {
      background: #424242;
      color: #fff;
      border-color: #424242;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
  }
  .cc-search {
    background: #f5f5f5;
    border-color: #bdbdbd;
    i {
      color: #424242;
    }
  }
}
.cc-count {
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 11px;
  background: linear-gradient(135deg, #1e88e5, #42a5f5);
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}
.cc-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #1e88e5;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.25s;
  &:hover,
  &.active {
    background: #1e88e5;
    color: #fff;
    border-color: #1e88e5;
    box-shadow: 0 2px 8px rgba(30, 136, 229, 0.35);
  }
}
.cc-arrow {
  transition: transform 0.3s;
  &.rotated {
    transform: rotate(180deg);
  }
}
.cc-search {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  background: #f1f6fd;
  border: 1px solid #bbdefb;
  overflow: hidden;
  i {
    font-size: 11px;
    color: #1e88e5;
  }
  input {
    width: 90px;
    border: 0;
    outline: 0;
    background: transparent;
    font-size: 12px;
  }
}
.cc-clear {
  cursor: pointer;
}
.cc-slide-enter-active,
.cc-slide-leave-active {
  transition: all 0.25s;
}
.cc-slide-enter,
.cc-slide-leave-to {
  opacity: 0;
  transform: scaleX(0.4);
}
.cc-chips {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.cc-more {
  cursor: pointer;
}
.cc-empty {
  color: #9e9e9e;
}
</style>
